import { createSingleApiWithFields } from '@/lib/api-base';
import {
  ManagerBalance,
  ManagerMovementsResponse,
} from '@/types/manager.model';
import { MANAGER_BALANCE_FIELDS } from './manager-balance-fields.config';
import { MANAGER_MOVEMENTS_FIELDS } from './manager-movements-fields.config';

/**
 * Gets manager balance data with dynamic typing based on field selectors.
 * This is the base method that makes the actual API call for manager balance.
 */
export const getManagerBalanceData = createSingleApiWithFields<
  ManagerBalance,
  typeof MANAGER_BALANCE_FIELDS
>('/managers/balance', MANAGER_BALANCE_FIELDS);

/**
 * Fetch current account movements for the authenticated manager.
 */
export const getManagerMovements = createSingleApiWithFields<
  ManagerMovementsResponse,
  typeof MANAGER_MOVEMENTS_FIELDS
>('/payments/me/movements', MANAGER_MOVEMENTS_FIELDS);
